/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
import { createPills } from './pills';

let currentFocus;

export const closeAllSuggestions = () => {
  const items = document.querySelectorAll('.suggestions-items');
  items.forEach( item => item.parentNode.removeChild(item));
  document.removeEventListener('click', closeDropdown)
};

export const suggestionsDropdown = (input, arr) => {

  ['input', 'click'].forEach( eventListener => {
    input.addEventListener( eventListener, event => {
      currentFocus = -1;
      const inputValue = input.value;
      const creatingDropdown = document.createElement('div');
      creatingDropdown.setAttribute('id', `${input.id}_suggestions`);
      creatingDropdown.setAttribute('class', 'suggestions-items');
      closeAllSuggestions();
      
      input.parentNode.appendChild(creatingDropdown);
      
      const addingSuggestions = suggestion => {
        document.addEventListener('click', closeDropdown)
        const creatingDropdownItem = document.createElement('div');
        creatingDropdownItem.innerHTML = `<strong>${suggestion.name.substr(0, inputValue.length)}</strong>`;
        creatingDropdownItem.innerHTML += suggestion.name.substr(inputValue.length);
        
        /**
          This input field hold the array value, so then
          on click function we assign this value to the main input
        */
        creatingDropdownItem.innerHTML += `<input type="hidden" value="${suggestion.name}">`;
        
        /**
          Inserting the Country/Continent value as a Pills
          and closing the list of autocompleted values
        */
        creatingDropdownItem.addEventListener('click', () => {
          createPills(creatingDropdownItem.getElementsByTagName('input')[0], true, suggestion);
          closeAllSuggestions();
        });
        creatingDropdown.appendChild(creatingDropdownItem);
      }
      
      arr.forEach( suggestion => {
        if (event.type === 'click') {
          addingSuggestions(suggestion)
        } else {
          if (suggestion.name.substr(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
            addingSuggestions(suggestion)
          }
        }
      });
    });
  })


  function removeActive(x) {
    for (let i = 0; i < x.length; i++) {
      x[i].classList.remove('suggestions-active');
    }
  }
  
  function addActive(x) {
    if (!x) return false;
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);
    x[currentFocus].classList.add('suggestions-active');
  }
  
  /* execute a function presses a key on the keyboard: */
  input.addEventListener('keydown', (e) => {
    let suggestionsItems = document.getElementById(`${input.id}_suggestions`);
    if (suggestionsItems) suggestionsItems = suggestionsItems.getElementsByTagName('div');
    if (e.keyCode === 40) { // Arrow DOWN
      currentFocus++;
      addActive(suggestionsItems);
    } else if (e.keyCode === 38) { // Arrow UP
      currentFocus--;
      addActive(suggestionsItems);
    } else if (e.keyCode === 13) { // ENTER
      e.preventDefault();
      if (currentFocus > -1) {
        // and simulate a click on the "active" item
        if (suggestionsItems) suggestionsItems[currentFocus].click();
        closeAllSuggestions();
      }
    }
  });
};


const closeDropdown = e => {
  if (!e.target.classList.contains('js-pills')) closeAllSuggestions()
}